export const ROUTE = {
  HOME: "/",
  LOGIN: "/login",
  BLOG: "/blog/:slug",
  CONTACT_US: "/contact-us",
  WISDOM_BATCH: "/wisdom-batch",
  PRIVACY: "/privacy",
  UMANG: "/umang",
  EVENT_VOLUNTEER: "/event/volunteer",
  EVENT_LIST: "/event/list",
  ABOUT: "/about",
  TNC: "/tnc",
  REFUND: "/refund",
  DYS: "/dys",
  DYS_LIST: "/dys/list",
  DYS_LIST_SESSIN: "/dys/list/:session_id",
};

export const CREATE_NEW_REGISTRATION = "/user/register";
export const FETCH_VOLUNTEER_LIST = "/user/volunteers";
export const FETCH_ALL_USERS = "/user/fetchAll";
export const MARK_ATTENDANCE = "/user/markAttendance";
export const UPDATE_USER = "/user/update";
export const DYS_LIST = "api/devotee/list";
